/**
 * Keep the in-page Set BoM rules view and a popped-out /bom/test-revision window
 * aligned on template, revision, and test SKU. Uses the storage event (other tabs only).
 */
export const BOM_TEST_SYNC_KEY = "sgs_bom_test_revision_v1";

export type BomTestSyncPayload = {
  templateId: number;
  revision: number;
  testSku: string;
  updatedAt: number;
};

export function parseBomTestSync(raw: string | null): BomTestSyncPayload | null {
  if (!raw) {
    return null;
  }
  try {
    const data = JSON.parse(raw) as Partial<BomTestSyncPayload>;
    if (
      typeof data.templateId !== "number" ||
      typeof data.revision !== "number" ||
      typeof data.testSku !== "string" ||
      typeof data.updatedAt !== "number"
    ) {
      return null;
    }
    return {
      templateId: data.templateId,
      revision: data.revision,
      testSku: data.testSku,
      updatedAt: data.updatedAt,
    };
  } catch {
    return null;
  }
}

export function writeBomTestSync(payload: Omit<BomTestSyncPayload, "updatedAt"> & { updatedAt?: number }): void {
  try {
    const full: BomTestSyncPayload = {
      ...payload,
      updatedAt: payload.updatedAt ?? Date.now(),
    };
    localStorage.setItem(BOM_TEST_SYNC_KEY, JSON.stringify(full));
  } catch {
    // storage full or disabled
  }
}
